import AILOGO from "@/assets/record/ic_ai.png";

const LogoHeader = () => {
  return (
    <div className="flex items-center px-3.5 py-2">
      <img className="w-10 h-10 mr-1" src={AILOGO} />
      <div className="text-4.5 font-600">AI会记</div>
    </div>
  );
};

export default LogoHeader;